<template>
   <div>
      <p><strong>Enter a URL pattern using regular expressions (RegEx).</strong></p>
      <p>
         Page views that match this pattern will be counted as rewards for your optimization strategy.
      </p>
      <p>
         <a 
            href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions" 
            target="_blank"
         >Learn more about Regular Expressions</a>
      </p>
   </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
   name: "RegExStep",
})
</script>
